import { render, staticRenderFns } from "./DetailTransaction.vue?vue&type=template&id=6e1ca4d5&scoped=true&"
import script from "./DetailTransaction.vue?vue&type=script&lang=js&"
export * from "./DetailTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1ca4d5",
  null
  
)

export default component.exports